import { reactive } from 'vue'
import axios from 'axios'

const campaignsState = reactive({
  campaigns: []
})

const CAMPAIGN_CACHE_TTL_MS = 10 * 60 * 1000
const campaignByIdCache = {}
const campaignByIdState = reactive({})
const emptyCampaignState = reactive({
  result: undefined,
  loading: false,
  loaded: true
})

const setCampaignCache = (campaignId, value) => {
  campaignByIdCache[campaignId] = {
    value,
    expiresAt: Date.now() + CAMPAIGN_CACHE_TTL_MS
  }
}

const ensureCampaignState = (campaignId) => {
  if (!campaignByIdState[campaignId]) {
    campaignByIdState[campaignId] = reactive({
      result: undefined,
      loading: false,
      loaded: false
    })
  }

  return campaignByIdState[campaignId]
}

export function useCampaigns () {
  const getCampaignsActive = async () => {
    const response = await axios.get('pub/campaigns/active')
    if (response.data && response.data.result) {
      campaignsState.campaigns = response.data.result.content
    }
  }

  const getCampaignById = (campaignId) => {
    if (!campaignId) {
      return emptyCampaignState
    }

    const cacheKey = String(campaignId)
    const campaignState = ensureCampaignState(cacheKey)
    const cached = campaignByIdCache[cacheKey]
    const now = Date.now()

    if (cached && cached.expiresAt > now) {
      campaignState.result = cached.value
      campaignState.loading = false
      campaignState.loaded = true
      return campaignState
    }

    if (campaignState.loading) {
      return campaignState
    }

    campaignState.loading = true
    ;(async () => {
      try {
        const response = await axios.get(`pub/campaigns/${campaignId}`)
        const campaign = response?.data?.result
        setCampaignCache(cacheKey, campaign || undefined)
        campaignState.result = campaign || undefined
      } catch (error) {
        setCampaignCache(cacheKey, undefined)
        campaignState.result = undefined
      } finally {
        campaignState.loading = false
        campaignState.loaded = true
      }
    })()

    return campaignState
  }

  return {
    campaignsState,
    getCampaignsActive,
    getCampaignById
  }
}
